/**
 * <pre>
 * Event service.
 *
 * Summary of responsibilities:
 *
 *  - provides abstraction layer for working with events.
 * </pre>
 *
 * @author Various
 * @namespace Common.Services.EventService
 */
const EventService = (function() {

  'use strict';

  // The legacy event bus.
  var _legacyEventBus;

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  /**
	 * Init.
	 *
	 * @memberOf Common.Services.EventService
	 *
	 * @param legacyEventBus 	{object} Refefence to the legacy NGX app events object.
	 */
  const init = (legacyEventBus) => {

    // Store injected properties.
    _legacyEventBus = legacyEventBus;
  };

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // Api Methods.

  /**
	 * Listen for an event.
	 *
	 * @memberOf Common.Services.EventService
	 *
	 * @param event {string} Colon separated event name.
	 * @param handler {function} Handler function to execute when event is raised.
	 */
  const listen = (event, handler) => {

    _legacyEventBus.on(event, handler);
  };

  /**
	 * Remove existing event listener.
	 *
	 * @memberOf Common.Services.EventService
	 *
	 * @param event {string} Colon separated event name.
	 * @param handler {function} Handler function to execute when event is raised.
	 */
  const unlisten = (event, handler) => {
    _legacyEventBus.off(event, handler);
  };

  /**
	 * Trigger an event.
	 *
	 * @memberOf Common.Services.EventService
	 *
	 * @param event {string} Colon separated event name.
	 * @param data {object} Object containing additional data to pass to the event handler.
	 */
  const trigger = (event, data) => {

    _legacyEventBus.trigger(event, data);
  };

  // Expose scoped properties.
  return {

    init: 	init,

    listen:   listen,
    unlisten: unlisten,
    trigger:  trigger
  };

}());

export default EventService;
